export default function homologado() {
  
    const btnJudicial = document.getElementById('btn-judicial');
    const btnExtraJudicial = document.getElementById('btn-extra-judicial');
    const leilaoJudicial = document.querySelector('.leilao-judicial');
    const leilaoExtraJudicial = document.querySelector('.leilao-extra-judicial');


    function toggleDiv(div) {
        div.classList.toggle('show');
    }

    btnJudicial.addEventListener('click', () => {
        toggleDiv(leilaoJudicial);
        leilaoExtraJudicial.classList.remove('show');
    });

    btnExtraJudicial.addEventListener('click', () => {
        toggleDiv(leilaoExtraJudicial);
        leilaoJudicial.classList.remove('show');
    });
  
}
